import React, { CSSProperties, ReactNode } from 'react';
import { FloatLabel } from 'primereact/floatlabel';
import Label from '../Label';
import { IntlShape, useIntl } from 'react-intl';
import { ReadWritePermissions } from '../../../Auth/components/PermissionGate';
import { ValidationResult } from '../../../util/validation/interfaces';
import { getHelp } from '../../../util/intl.utils';

export interface LabelledProps {
  id: string;
  label?: string;
  labelProps?: any;
  title?: string;
  titleProps?: any;
  validation?: ValidationResult;
  required?: boolean;
  permissions?: ReadWritePermissions;
  disabled?: boolean;
  hidden?: boolean;
  wrapperClassName?: string;
  wrapperStyle?: CSSProperties;
  isNew?: boolean;
}

interface _LabelledProps extends LabelledProps {
  children: ReactNode;
}

export const Labelled = (props: _LabelledProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;

  switch (true) {
    case (props.label === undefined && props.title === undefined):
      return props.children;
    case (props.label !== undefined && props.title !== undefined):
      return props.children;
    case (props.label !== undefined && props.title === undefined):
      return (
        <FloatLabel className={props.wrapperClassName} style={props.wrapperStyle}>
          {props.children}
          <Label
            label={intl.formatMessage({id: `${props.label}.label`}, props.labelProps)}
            validation={props.validation}
            required={props.permissions?.required || props.required}
            disabled={disabled}
            hidden={props.hidden}
            htmlFor={props.id}
            isNew={props.isNew}/>
        </FloatLabel>
      );
    case (props.label === undefined && props.title !== undefined):
    default:
      return (
        <div className={['flex flex-column gap-1', props.wrapperClassName].filter(Boolean).join(' ')} style={props.wrapperStyle}>
          <h4 className={'m-0 w-12'}>
            <Label
              label={intl.formatMessage({id: `${props.title}.label`}, props.titleProps)}
              validation={props.validation}
              required={props.permissions?.required || props.required}
              htmlFor={props.id}
              help={getHelp(intl, `${props.title}.help`)}
              hidden={props.hidden}
              disabled={disabled}
              isNew={props.isNew}
            />
          </h4>
          {props.children}
        </div>
      );
  }
};
